function SocketsCtrl($scope, $timeout, $state, $interval, GeneralUtilsService, SiteService){
    $scope.datamodified = null;
    $scope.socketActions = {"accountId":null};
    $scope.selectedSockets = [];
    $scope.shouldRefresh = true;
    $scope.socketVersion = {upgradeType: "LATEST", upgradePath: "UPGRADE_SCHEDULER"}

    var cancelRefresh = false;

    $scope.tableConfig = {
        keepPageOnRefresh: true,
        titleSearch: "Sockets",
        dataURL : function() {
            cancelRefresh = true;
            var accountId = $state.params.accountId;
            if(accountId){
                return "/sockets?accountId=" + accountId;
            }
            else {
                return "/sockets";
            }
        },
        filter: true,
        showTable: false,
        fixedLayout: true,
        processData : function(items){
            cancelRefresh = false;
            /*$timeout(function(){
                if ($scope.shouldRefresh && !cancelRefresh) {
                    $scope.datamodified = new Date().getTime();
                }
            }, 5000, false);*/
        },
        fields : [
            {"label":"SocketID","path":"socketID","template":"<span>{{item.socketID}}</span>"},
            {"label":"Status","path":"registrationStatus","registrationStatus":"name","template":"<span>{{item.registrationStatus | capitalize}}</span>"},
            {"label":"Role","path":"isPrimary","template":"{{item.registrationStatus === 'REGISTERED' || item.registrationStatus === 'ASSIGNED_SITE' ? (item.isPrimary ? 'Primary' : 'Secondary') : ''}}"},
            {"label":"Live from","path":"wakeTime","template":"<span ng-if='item.wakeTime'>{{item.wakeTime | toUTC | date:'short'}}</span>"},
            {"label":"Creation Date","path":"creationDate","template":"<span ng-if='item.creationDate'>{{item.creationDate | toUTC | date:'short'}}</span>"},
            {"label":"Account","path":"Account.name","template":"<span>{{item.accountName}}</span>"},
            {"label":"Rls. Grp.","path":"Account.releaseGroup","template":"<span>{{item.releaseGroup | capitalize}}</span>"},
            {"label":"Site","path":"Site.name","template":"<span>{{item.siteName}}</span>"},
            {"label":"Last Upgrade","path":"versionUpdateTime","template":"<span ng-if='item.versionUpdateTime'>{{item.versionUpdateTime | toUTC | date:'short'}}</span>"},
            {"label":"Version","path":"version","template":"<span ng-show='item.version'>{{item.version | socketVersion}}</span>"},
            {"label":"Upgrade Status","path":"upgradeStatus","template":"<span>{{(item.upgradeStatus ? item.upgradeStatus : item.upgradeStatus && " +
            "item.upgradeStatus.substring(0, 6) === 'socket' ? 'Waiting to send file' : item.upgradeStatus  | capitalize )}}</span></span>", noSort: true,},
            {"label": "Target Version", noSort: true, "template":"{{item.versionUpdateRequested}}"},
            {"label":"Scheduled Upgrade","path":"updateAfter","template":"<span>{{item.updateAfter | date:'short'}}</span>"},
            {"label":"IP","path":"ip","template":"<span>{{item.ip}}</span>"},
            {"label":"Location","path":"location","template":"<span>{{item.location}}</span>", noSort: true},
            {"label":"Model","path":"model","template":"<span>{{item.model.name}}</span>"},
            {"label":"Postponement Reason","path":"postponeReason","template":"<span>{{item.postponeReason}}</span>"},
            {"label":"Upgrade Path","path":"upgradePath","template":"<span>{{item.upgradePath}}</span>", noSort: true},
            {"label":"initial upgrade retries","path":"initialUpgradeRetries","template":"<span>{{item.initialUpgradeRetries}}</span>"},
        ],
        type : "Socket",
        actions: [],
        pageSize: 9,
        hideCheckboxes:true,
        searchField: 'socketID',
        sortField: 'socketID',
        removeConfirmation: function (socketsToRemove) {
            const assignedSiteStatus = ['ASSIGNED_SITE', 'ASSIGNED_SITE_PENDING_REGISTER', 'REGISTERED'];
            const socketsAssignedToSite = socketsToRemove.filter(
                socket => assignedSiteStatus.includes(socket.registrationStatus) && socket.siteName != null
            );
            if (socketsAssignedToSite.length > 0) {
                const socketsToUnassignNames = socketsAssignedToSite.map(socket => socket.name).join(', ');
                return 'Please note, socket(s) which are assigned to site "' + socketsToUnassignNames + '" will also be unassigned';
            }
            return null;
        },
    };

    $scope.closeDowngradeVersionDlg = function () {
        delete $scope.$root.errors['socketMultipleTypesError'];
        $scope.$root.closePopup('downgradeVersionDlg')
    };

    $scope.closeRegisterVersionDlg = function () {
        delete $scope.$root.errors['socketMultipleTypesError'];
        $scope.$root.closePopup('registerVersionDlg')
    };

    $scope.closeUpgradeVersionDlg = function () {
        delete $scope.$root.errors['socketMultipleTypesError'];
        $scope.$root.closePopup('upgradeVersionDlg')
    };

    $scope.closeRebootSocketDlg = function () {
        delete $scope.$root.errors['socketMultipleTypesError'];
        $scope.$root.closePopup('rebootSocketDlg')
    };

    $scope.onSocketUpgrade = function () {
        $scope.$root.closePopup('upgradeVersionDlg');
        $scope.$root.openPopup('socketUpgradeConfirmation');
    };

    $scope.tableConfig.addAction = function(){
        $scope.newSocket = {id:GeneralUtilsService.getRandomId(),"name":""};
        if($scope.accountId){
            $scope.newSocket.account = _.findWhere($scope.accounts, {id: $scope.accountId});
        }

        SiteService.getConnectionTypes($state.params.accountId, function(data) {
            $scope.socketTypes = _.chain(data.siteConnTypes)
                    .filter(connType => connType.socketModelTypeConfiguration && !connType.socketModelTypeConfiguration.automaticallyManaged)
                    .map((connType) => connType.socketModelTypeConfiguration)
                    .value();
            $scope.$root.openPopup('addSocketDlg');
        });
    };

    $scope.tableConfig.actions = ["remove"];
    $scope.tableConfig.specialActions = [{
        func: function(selectedItems) {
            $scope.selectedSockets  = selectedItems;
            $scope.filterType = {platform: new Set(selectedItems.map(function(element){ return element.platform;}))};
            if($scope.filterType && $scope.filterType.platform && $scope.filterType.platform.size>1){
                $scope.$root.errors['socketMultipleTypesError'] = "Selected sockets have more then one platform type";
            }
            $scope.$root.openPopup('upgradeVersionDlg');
        },
        icon: "toggle-up",
        tooltip: "Upgrade Version"
    }, {
        func: function(selectedItems) {
            $scope.selectedSockets = selectedItems;
            $scope.filterType = {platform: new Set(selectedItems.map(function(element){ return element.platform;}))};
            if($scope.filterType && $scope.filterType.platform && $scope.filterType.platform.size>1){
                $scope.$root.errors['socketMultipleTypesError'] = "Selected sockets have more then one platform type";
            }
            $scope.$root.openPopup('downgradeVersionDlg');
        },
        icon: "toggle-down",
        tooltip: "Downgrade Version"
    }, {
        func: function(selectedItems) {
            $scope.selectedSockets = selectedItems;
            $scope.socketActions.accountId = $scope.accountId;
            $scope.$root.openPopup('rebootSocketDlg');
        },
        icon: "restart",
        tooltip: "Reboot socket"
    },
        {
        func: function(selectedItems) {
            $scope.selectedSockets = selectedItems;
            $scope.socketActions.accountId = $scope.accountId;
            $scope.$root.openPopup('assignAccountDlg');
        },
        icon: "transfer",
        tooltip: "Assign Account"
    }, {
        func: function(selectedItems) {
            $scope.selectedSockets = selectedItems;
            $scope.$root.openPopup('abortUpgradeDlg');
        },
        icon: "url-block",
        tooltip: "Abort Upgrade"
    },{
        func: function(selectedItems) {
            $scope.selectedSockets = selectedItems;
            $scope.$root.openPopup('resetRegistrationUpgradeStatusDlg');
        },
        icon: "edit",
        tooltip: "Reset registration upgrade status"
    }, {
        func: function(selectedItems) {
            $scope.$root.openPopup('socketsSyncConfirmation');
        },
        icon: "roundabout",
        tooltip: "Sync with Salesforce"
    }, {
            func: function(selectedItems) {
                $scope.selectedSockets = selectedItems;
                $scope.$root.openPopup('setSocketsAsDone');
            },
            icon: "saved",
            tooltip: "Set sockets as done"
        },
        {
            func: function(selectedItems) {
                $scope.selectedSockets = selectedItems;
                $scope.$root.openPopup('fixAssignedPendingRegisterSockets');
            },
            icon: "optimized",
            tooltip: "Fix Assigned pending resigter sockets"
        },
        {
            func: function (selectedItems) {
                $scope.selectedSockets = selectedItems;
                if (selectedItems.length === 0) {
                    $root.alert('please select a socket');
                    return;
                }

                if (selectedItems.length > 1) {
                    $scope.$root.alert('Can only register a single socket at a time');
                    return;
                }


                $scope.registerSocketVersion = {
                    command: 'register',
                    serial: selectedItems[0].socketID,
                    hash: 'randomHash',
                    deviceId: '11097',
                    platform: selectedItems[0].platform,
                    version: selectedItems[0].version,
                };

                $scope.$root.openPopup('registerVersionDlg');
            },
            icon: 'config',
            tooltip: 'Register',
        },

    ];
    $scope.tableConfig.hideCheckboxes = false;

    /**
      * used to filter the list of accounts which can be assigned to a socket
      * allowing only account != RESELLER
    **/
    $scope.filterReseller = function(account){
        return account && account.accountType && account.accountType != "RESELLER";
    };

    // Fetch accounts
    store.fetch({
        path: "/accounts",
        method: 'POST',
        queryParams: {'viewType':'SimpleList'},
        success: function(data) {
            data.items.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : (a.name.toLowerCase() < b.name.toLowerCase()) ? -1 : 0);
            $scope.accounts = [{id:-1,name:''}].concat(data.items);
        }
    });



    /**
     * return the store configuration dynamically for the rolling button since we determine the type
     * of configuration by the socketID for each save
     * @returns {*}
     */
    $scope.getStoreConfiguration = function () {
        var params = {'type':'socket','save':true, 'accountId': $scope.newSocket.account.id};
        var socketIds = $scope.newSocket.socketID.split(",");
        if (socketIds.length === 1) {
            return {
                data: {
                    socket: $scope.newSocket,
                    accountId: $scope.newSocket.account.id
                },
                dataObj: 'json',
                queryParams: params,
                url: "/addSocket"
            }
        }
        else{
            var sockets = [];
            socketIds.forEach(function(item) {
                var newSock = {id:GeneralUtilsService.getRandomId(),name:"",socketID:item,account:$scope.newSocket.account,model:$scope.newSocket.model };
                sockets.push(newSock);
            });
            return {
                data: sockets,
                dataObj: 'json',
                queryParams: params,
                url: "/addMultipleEntities"
            }
        }
    };

    /**
     * this function will be triggered before the save of the rolling button will be executed
     */
    $scope.preSave = function () {
        if(!$scope.newSocket.socketID || $scope.newSocket.socketID === ""){
            $scope.$root.alert("Please insert socketID");
            return false;
        }
        var socketIds = $scope.newSocket.socketID.split(",");
        // add single entity
        if (socketIds.length != 1) {
            var sockets = [];
            socketIds.forEach(function(item) {
                var newSock = {id:GeneralUtilsService.getRandomId(),name:"",socketID:item,account:$scope.newSocket.account,model:$scope.newSocket.model };
                sockets.push(newSock);
            });
        }
        return true;
    };

    $scope.syncSockets = function (data) {
        store.fetch({
            path: "/syncSocketsWithSalesforce",
            method: 'POST',
            queryParams: {accountId: $state.params.accountId},
            success: function(data) {
                $scope.progressId = data.id;
                $scope.$root.openPopup('socketsSyncDialog');
                var timer = $interval(function () {
                    store.fetch({
                        path: '/progress',
                        queryParams: { id: $scope.progressId },
                        success: function (data) {
                            if (data === null) {
                                $interval.cancel(timer);
                                $scope.datamodified = new Date().getTime();
                                $scope.$digest();
                                $scope.$root.closePopup('socketsSyncDialog');
                            }
                        },
                    });
                }, 500);
            }
        });
    }

    /**
     * after execution of the rolling button save this function will be triggered
     * @param data
     */
    $scope.postSave = function (data) {
        $scope.$root.handleServerResponse(data,"newSocket", "Socket added successfully");
        if(data.status !== "ERROR"){
            $scope.tableConfig.selectedId = data.model.id;
            $scope.datamodified = new Date().getTime();
            $scope.$root.closePopup('addSocketConfirmation');
        }
    };

    $scope.onSave = function() {
        $scope.closePopup('addSocketDlg');
        $scope.openPopup('addSocketConfirmation');
    };

    $scope.rebootSocket = function() {
        // make sure user has selected sockets
        var selectedItems = $scope.selectedSockets;
        var len = selectedItems.length;
        if (len === 0) {
            $scope.$root.alert("Please select socket");
            return;
        } else if (len > 1) {
            $scope.$root.alert("Can only reboot a single socket at a time");
            return;
        }

        store.save({
            path: "/rebootSocket",
            data: [selectedItems[0].id],
            queryParams: { "socketRecordId": selectedItems[0].id },
            success: function (data) {
                $scope.$root.handleServerResponse(data, "", 'Selected socket is being rebooted');
                $scope.datamodified = new Date().getTime();
                $scope.$root.closePopup('rebootSocketDlg');
            },
            error: function (data) {
                $scope.$root.handleServerResponse({status:"ERROR", notifications:[{field:"", message:data.reason, status:"ERROR"}]})
                $scope.$root.closePopup('rebootSocketDlg');
            }
        });
    }

    $scope.onAssignSocketToAccount = function() {
        $scope.closePopup('assignAccountDlg');
        $scope.openPopup('assignSocketToAccountConfirmation');
    }

    $scope.assignSocket = function() {
        var selectedItems = $scope.selectedSockets;
        var len = selectedItems.length;
        if(len === 0) {
            $scope.$root.alert("Please select sockets");
            return;
        }
        var sockets = [];
        selectedItems.forEach(function(item) {
            sockets.push(item.id);
        });
        store.save({
            path: "/assignAccountToSockets",
            data: sockets,
            dataObj: 'json',
            queryParams: {'accountId':$scope.socketActions.accountId},
            success: function(data) {
                $scope.$root.handleServerResponse(data, "" , 'Account successfully assigned to selected sockets');
                $scope.$root.closePopup('assignSocketToAccountConfirmation');
            }
        });

    };

    $scope.resetRegistrationUpgradeStatus = () => {
        let selectedItems = $scope.selectedSockets;
        let len = selectedItems.length;
        if(len === 0) {
            $scope.$root.alert("Please select sockets");
            return;
        }
        let sockets = [];
        selectedItems.forEach(function(item) {
            sockets.push(item.id);
        });
        store.save({
            path: "/resetRegistrationUpgradeStatus",
            data: sockets,
            dataObj: 'json',
            success: function(data) {
                $scope.$root.handleServerResponse(data, "" , 'Successfully reset ' + data.notifications[0].message + ' socket upgrades');
                $scope.datamodified = new Date().getTime();
                $scope.$root.closePopup('resetRegistrationUpgradeStatusDlg');
            }
        });
    }

    $scope.setSocketsAsDone = () => {
        let selectedItems = $scope.selectedSockets;
        let len = selectedItems.length;
        if(len === 0) {
            $scope.$root.alert("Please select sockets");
            return;
        }
        let sockets = [];
        selectedItems.forEach(function(item) {
            sockets.push(item.socketID);
        });
        store.save({
            path: "/setSocketsAsDone",
            data: sockets,
            dataObj: 'json',
            success: function(data) {
                $scope.$root.handleServerResponse(data, "" , 'Successfully set sockets as done');
                $scope.datamodified = new Date().getTime();
                $scope.$root.closePopup('setSocketsAsDone');
            }
        });
    }

    $scope.fixAssignedPendingRegisterSockets = () => {
        let selectedItems = $scope.selectedSockets;
        let len = selectedItems.length;
        if(len === 0) {
            $scope.$root.alert("Please select sockets");
            return;
        }
        let sockets = [];
        selectedItems.forEach(function(item) {
            sockets.push(item.id);
        });
        store.save({
            path: "/fixAssignedPendingRegisterSockets",
            data: sockets,
            dataObj: 'json',
            success: function(data) {
                const fixedSockets = data.data && data.data.items ? data.data.items.
                filter(response => response.status === 'FIXED').
                map(response => response.name) : [];
                const responseStr = 'Successfully fixed sockets: '.
                concat(fixedSockets.length ? fixedSockets.join(',') : "[]").
                concat('. For more details see the response');
                $scope.$root.handleServerResponse(data, "" , responseStr);
                $scope.datamodified = new Date().getTime();
                $scope.$root.closePopup('fixAssignedPendingRegisterSockets');
            }
        });
    }

    $scope.abortUpgrade = function() {
        var selectedItems = $scope.selectedSockets;
        var len = selectedItems.length;
        if(len === 0) {
            $scope.$root.alert("Please select sockets");
            return;
        }
        var sockets = [];
        selectedItems.forEach(function(item) {
            sockets.push(item.id);
        });
        store.save({
            path: "/abortSocketUpgrade",
            data: sockets,
            dataObj: 'json',
            success: function(data) {
                $scope.$root.handleServerResponse(data, "" , 'Successfully aborted ' + data.notifications[0].message + ' socket upgrades');
                $scope.datamodified = new Date().getTime();
                $scope.$root.closePopup('abortUpgradeDlg');
            }
        });

    };

    // send to server request to upgrade socket
    $scope.downgradeSocketVersion = function() {
        // make sure user has selected sockets
        var selectedItems = $scope.selectedSockets;
        var len = selectedItems.length;
        if(len === 0) {
            $scope.$root.alert("Please select sockets");
            return;
        }
        // collect sockets to upgrade
        var sockets = [];
        selectedItems.forEach(function(item) {
            sockets.push(item.id);
        });

        // send request to server
        store.save({
            path: "/downgradeSocketVersion",
            data: sockets,
            dataObj: 'json',
            success: function(data) {
                $scope.$root.handleServerResponse(data, "" , 'Selected sockets are being downgraded');
                $scope.datamodified = new Date().getTime();
                $scope.$root.closePopup('downgradeVersionDlg');
            }
        });
    };

    // send to server request to register socket
    $scope.onRegisterSocketVersion = function() {
        // make sure user has selected sockets
        const selectedItems = $scope.selectedSockets;
        var socket = selectedItems[0];

        const registerSocketVersion = $scope.registerSocketVersion;

        store.action({
            path: registerSocketVersion.command,
            data: {
                serial: socket.socketID,
                r: registerSocketVersion.hash,
                device_id: registerSocketVersion.deviceId,
                version: registerSocketVersion.version,
                platform: registerSocketVersion.platform,
            },
            dataObj: 'json',
            success: function (data) {
                $scope.$root.handleServerResponse(data, '', 'Selected sockets are being registered');
                $scope.datamodified = new Date().getTime();
                $scope.$root.closePopup('registerVersionDlg');
            }
        });

    };


    // send to server request to upgrade socket
    $scope.upgradeSocketVersion = function() {
        // make sure user has selected sockets
        var selectedItems = $scope.selectedSockets;
        var len = selectedItems.length;
        if(len === 0) {
            $scope.$root.alert("Please select sockets");
            return;
        }
        // collect sockets to upgrade
        var sockets = [];
        selectedItems.forEach(function(item) {
            sockets.push(item.id);
        });

        var params = {
            'upgradeType': $scope.socketVersion.upgradeType,
            'upgradePath': $scope.socketVersion.upgradePath,
        };
        if($scope.socketVersion && $scope.socketVersion.version && $scope.socketVersion.version.fileName){
            params.version = $scope.socketVersion.version.fileName;
        }

        // send request to server
        store.save({
            path: "/upgradeSocketVersion",
            data: sockets,
            dataObj: 'json',
            queryParams: params,
            success: function(data) {
                $scope.$root.handleServerResponse(data, "" , 'Selected sockets are being upgraded');
                $scope.datamodified = new Date().getTime();
                $scope.$root.closePopup('socketUpgradeConfirmation');
            }
        });
    };

    $scope.toggleAutoRefresh = function(){
        if(!$scope.shouldRefresh){
            $scope.datamodified = new Date().getTime();
        }
        $scope.shouldRefresh = !$scope.shouldRefresh;
    };
}

